export enum MeritManuallyChangedState {
  None = 'None',
  Activated = 'Activated',
  Deactivated = 'Deactivated'
}
